<main class="main-wrap-ng">
  <div class="content-blk">
    <div class="container">
      <h5 class="page-title">
        Invoice List
      </h5>


      <div class="white-background dv-strdmn-invslst">
        <form [formGroup]="searchForm">
          <div class="srch-flt-rt dv-srch-invce">
            <mat-form-field class="example-full-width" floatLabel="never">
              <mat-label>invoice#, order# or po#</mat-label>
              <input matInput placeholder="" formControlName="searchList" ng-model-options="{debounce: 10000}"
                (change)="fn_searchClient(searchForm)">
            </mat-form-field>
            &nbsp;&nbsp;
            <mat-form-field>
              <mat-label>Start invoice date</mat-label>
              <input [max]="searchForm.controls.endDate.value" matInput [matDatepicker]="startpicker"
                placeholder="" (dateChange)="fn_searchClient(searchForm)" formControlName="startDate">
              <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
              <mat-datepicker #startpicker></mat-datepicker>
            </mat-form-field>
            &nbsp;&nbsp;
            <mat-form-field>
              <mat-label>End invoice date</mat-label>
              <input [min]="searchForm.controls.startDate.value" matInput [matDatepicker]="endpicker"
                placeholder="" (dateChange)="fn_searchClient(searchForm)" formControlName="endDate">
              <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
              <mat-datepicker #endpicker></mat-datepicker>
            </mat-form-field>
            &nbsp;&nbsp;
            <label class="lbl-exprt">Export reports (excel) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i
                (click)="fn_downloadExcel(searchForm)" class="fa fa-download"></i></label>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button class="btn btn-danger cler-btn" (click)="fn_clearFilter()">Clear Filter</button>
          </div>
        </form>
        <div class="clearfix"></div>
        <div class="search-results" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="10"
          (scrolled)="fn_GetInvoiceList()">
          <div class="sp-admin-list-tbl pro-tble-outer">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Invoice#</th>
                    <th>Order#</th>
                    <th>Invoice Date</th>
                    <th>Due Date</th>
                    <th>PO#</th>
                    <th>Invoice Amount</th>
                    <th>Balance</th>
                    <!--<th class="text-center">Actions</th>-->
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="InvoiceList?.length == 0">
                    <td colspan="8" class="text-center">
                      No record(s) available
                    </td>
                  </tr>
                  <tr *ngFor="let item of InvoiceList; let i=index">
                    <td>{{i + 1}}</td>
                    <td> <a target="_blank" title="export invoice" herf="#" style="color:deepskyblue"
                        (click)="showPdf(item.InvoiceNumber)">{{item.InvoiceNumber}}</a></td>
                    <td>{{item.SalesOrder}}</td>
                    <td>{{item.Date}}</td>
                    <td>{{item.DueDate}}</td>
                    <td>{{item.CustomerPO}}</td>
                    <td>{{item.Total}}</td>
                    <td>{{item.Balance}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- <a target="_blank" herf="#"  (click)="showPdf()">Export</a>-->
        <!-- <mat-card class="spg-mat-card mat-card-cmn" style="display: none;" [ngStyle]="{'display': isDisplay}">
          <mat-card-header>
          </mat-card-header>
          <mat-card-content>
            <div class="text-center">
              <span> No records available</span>
            </div>
          </mat-card-content>
        </mat-card> -->
      </div>
    </div>
  </div>
</main>